import React from "react";
import { 
  Box, 
  Container, 
  Grid, 
  Link, 
  Stack,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { SITE_CONFIG } from "../config";

const linkStyle = {
  color: "text.secondary",
  textDecoration: "none",
  transition: "all 0.2s ease",
  display: "inline-block",
  fontSize: { xs: "0.875rem", sm: "0.9rem" },
  "&:hover": {
    color: "primary.main",
    transform: "translateX(4px)",
  },
};

export default function Footer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      component="footer"
      sx={{
        pt: { xs: 3, sm: 4, md: 5 },
        pb: { xs: 4, sm: 6, md: 8 },
        borderTop: "1px solid",
        borderColor: "divider",
        mt: { xs: 4, sm: 6 },
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 3, sm: 4, md: 5 }}>
          {/* Kolumna: Informacje */}
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography 
              variant={isMobile ? "subtitle1" : "h6"} 
              gutterBottom
              sx={{ 
                fontWeight: 600,
                mb: { xs: 1.5, sm: 2 }
              }}
            >
              Informacje
            </Typography>

            <Stack spacing={1}>
              <Link href="/o-nas" sx={linkStyle}>
                O nas
              </Link>
              <Link href="/regulamin" sx={linkStyle}>
                Regulamin
              </Link>
              <Link href="/mapa-kategorii" sx={linkStyle}>
                Mapa kategorii
              </Link>
            </Stack>
          </Grid>

          {/* Kolumna: Przydatne linki */}
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography 
              variant={isMobile ? "subtitle1" : "h6"} 
              gutterBottom
              sx={{ 
                fontWeight: 600,
                mb: { xs: 1.5, sm: 2 }
              }}
            >
              Przydatne linki
            </Typography>

            <Stack spacing={1}>
              <Link href="/polityka-prywatnosci" sx={linkStyle}>
                Polityka prywatności
              </Link>
              <Link href="/pomoc" sx={linkStyle}>
                Pomoc
              </Link>
              <Link href="/faq" sx={linkStyle}>
                FAQ
              </Link>
            </Stack>
          </Grid>

          {/* Kontakt */}
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography 
              variant={isMobile ? "subtitle1" : "h6"} 
              gutterBottom
              sx={{ 
                fontWeight: 600,
                mb: { xs: 1.5, sm: 2 }
              }}
            >
              Kontakt
            </Typography>

            <Link
              href={`mailto:${SITE_CONFIG.CONTACT_EMAIL}`}
              color="text.secondary"
              underline="hover"
              sx={{
                transition: "all 0.2s ease",
                fontSize: { xs: "0.875rem", sm: "0.9rem" },
                "&:hover": {
                  color: "primary.main",
                  transform: "translateX(4px)",
                },
                display: "inline-block",
                wordBreak: "break-all",
              }}
            >
              {SITE_CONFIG.CONTACT_EMAIL}
            </Link>
          </Grid>

          {/* Prawa autorskie */}
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography 
              variant={isMobile ? "subtitle1" : "h6"} 
              gutterBottom
              sx={{ 
                fontWeight: 600,
                mb: { xs: 1.5, sm: 2 }
              }}
            >
              Informacje prawne
            </Typography>

            <Typography 
              variant="body2" 
              color="text.secondary"
              sx={{ 
                fontSize: { xs: "0.8rem", sm: "0.875rem" },
                lineHeight: 1.6
              }}
            >
              © {new Date().getFullYear()} {SITE_CONFIG.NAME}.
              <Box component="br" sx={{ display: { xs: "block", sm: "none" } }} />
              Wszelkie prawa zastrzeżone.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
